import { Select } from "@powerdiary/components-library/lib";

export type InvoiceFilter = "all" | "paid" | "unpaid";

const FILTER_OPTIONS = [
    { label: "All", value: "all" as InvoiceFilter },
    { label: "Paid", value: "paid" as InvoiceFilter },
    { label: "Unpaid", value: "unpaid" as InvoiceFilter },
];

interface InvoiceFilterDropdownProps {
    value: InvoiceFilter;
    onChange: (value: InvoiceFilter) => void;
    className?: string;
    dataTestIdSuffix?: string;
}

export default function InvoiceFilterDropdown({
    value,
    onChange,
    className,
    dataTestIdSuffix = "invoice_filter",
}: Readonly<InvoiceFilterDropdownProps>) {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value as InvoiceFilter);
    };

    return (
        <Select
            options={FILTER_OPTIONS}
            value={value}
            onChange={handleChange}
            dataTestIdSuffix={dataTestIdSuffix}
            size="small"
            className={className}
            sx={{ minWidth: 150 }}
            inputProps={{
                "data-test-id": `input_${dataTestIdSuffix}`,
            }}
        />
    );
}
